import React, { FC, forwardRef } from 'react';

import * as Checkbox from '@radix-ui/react-checkbox';
import clsx from 'clsx';

import { CheckIcon } from '@components/icons';

import styles from './StyledCheckbox.module.scss';

export type StyledCheckboxProps = Readonly<{
    id?: string;
    value?: boolean;
    name?: string;
    onChange?: (value: boolean) => void;
    onBlur?: () => void;
    className?: string;
    hasError?: boolean;
    isDisabled?: boolean;
}>;

export const StyledCheckbox: FC<StyledCheckboxProps> = forwardRef<
    HTMLButtonElement,
    StyledCheckboxProps
>((props, ref) => {
    const {
        id,
        value,
        name,
        onChange,
        onBlur,
        className,
        hasError = false,
        isDisabled = false,
    } = props;

    return (
        <Checkbox.Root
            ref={ref}
            id={id}
            name={name}
            checked={value}
            onCheckedChange={onChange}
            onBlur={onBlur}
            className={clsx(styles.control, hasError && styles.hasError, className)}
            disabled={isDisabled}
        >
            <Checkbox.Indicator className={styles.indicator}>
                <CheckIcon className={styles.checkIcon} />
            </Checkbox.Indicator>
        </Checkbox.Root>
    );
});

StyledCheckbox.displayName = 'StyledCheckbox';
